import ModelInterface from "../../../interfaces/model/ModelInterface";

export default function Description({model}:{model: ModelInterface | undefined}) {
    const descripton = model?.extra_param.description ? model?.extra_param.description: ''

    return (<><div className="product__tabs-cont product__description desc__block" dangerouslySetInnerHTML={{__html: descripton}}></div></>)
}